export enum LocalStorageNames {
  CoreReturnUrl = 'CORE_Return_Url',
  CoreDeveloperId = 'Core_DeveloperId',
  CoreBuildingId = 'Core_BuildingId',
  CoreBuildingName = 'Core_Building_Name'
};